import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import {HelpersService} from "../../../services/tools/helpers.service";
import { ErrorModalComponent } from '../../tools/modals/error-modal/error-modal.component';
import { ReporteEquilibrioKRService } from '../../../services/reporte-equilibrio-kr.service';
declare var $;

@Component({
  selector: 'app-detalles-kr-modal',
  templateUrl: './detalles-kr-modal.component.html',
  styleUrls: ['./detalles-kr-modal.component.scss']
})
export class DetallesKRModalComponent implements OnInit {
  public movimientos: any[] = [];
  public loading: boolean = true;
  public not_result: boolean = true;
  @Output() public goToCallback: EventEmitter<string> = new EventEmitter;

  constructor(  private helperService: HelpersService,
                private reporteEqulibrioKRService: ReporteEquilibrioKRService
    ) {
  }

  ngOnInit() {
  }

  close(){
    $('#detalles-modal').modal('hide');
  }

  open(data) {
    
    if (data.idConceptos && data.fechaInicial && data.fechaFinal) {
      this.getMovimientos(data);
      $('#detalles-modal').modal('show');
    }
  }

  getMovimientos(data) {
    this.loading = true;
    this.movimientos = [];
    this.reporteEqulibrioKRService.getMovimientos(data.idConceptos, data.fechaInicial, data.fechaFinal, data.idObras)
      .subscribe(response => {
        const content_response = response.json().content;
        console.log('content_response movimientos ', content_response);
        this.movimientos = content_response;
        this.loading = false;
        this.not_result = (this.movimientos.length <= 0);
      }, error => {
        this.helperService.httpGlobalError(error);
        console.log('error movimientos ', error);
        this.loading = false;
        this.not_result = true;
      })
  }

  isTraspasoIngreso(movimientoObra) {

    if (!movimientoObra.conceptos) {
      return false;
    }
    const isTraspasoIngreso = (movimientoObra.conceptos.traspaso == 1 && movimientoObra.tipoMovimiento == 2)? true: false;
    return isTraspasoIngreso;
  }

  getTipoMovimiento( movimiento ) {
    if (movimiento.conceptos.traspaso == 1) {
      return 'TRASPASO';
    }
    
    return (movimiento.tipoMovimiento == 2) ? 'INGRESO' : 'EGRESO';
  }

  isTipoMovimiento( tipoMovimiento, movimiento = null) {
    if (tipoMovimiento == 4 && movimiento.conceptos.traspaso == 1) {
      return true;
    }
    if (tipoMovimiento == movimiento.tipoMovimiento && movimiento.conceptos.traspaso != 1) {
      return true;
    }
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/reporte-equilibrio-kr/detalles-kr-modal/detalles-kr-modal.component.ts